import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../../utils/api';

interface LocalProjectsProps {
    localityName: string;
    projects: any[];
}

const LocalProjects: React.FC<LocalProjectsProps> = ({ localityName, projects }) => {
    if (!projects || projects.length === 0) return null;

    return (
        <div className="container mx-auto px-4 py-20 max-w-7xl border-t border-slate-100">
            <div className="mb-10 flex justify-between items-end">
                <div>
                    <h2 className="text-2xl font-bold text-black mb-2">Projects in {localityName}</h2>
                    <p className="text-black text-sm font-bold">Explore top residential projects in this area</p>
                </div>
                <Link to="/project-list" className="text-black font-black text-[10px] tracking-widest uppercase hover:opacity-70 transition-opacity underline">View All</Link>
            </div>

            <div className="relative group overflow-hidden">
                <div className="flex gap-6 overflow-x-auto no-scrollbar pb-8 scroll-smooth">
                    {projects.map((project) => (
                        <Link 
                            key={project._id} 
                            to={`/project-details/${project.slug || project._id}`}
                            className="min-w-[320px] max-w-[320px] bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group/card flex flex-col"
                        >
                            <div className="relative h-48 overflow-hidden">
                                <img 
                                    src={getImageUrl(project.featuredImage)} 
                                    alt={project.name}
                                    className="w-full h-full object-cover group-hover/card:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute top-4 left-4">
                                    <span className="bg-black/80 backdrop-blur-md text-white px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest leading-none">
                                        {project.projectStatus || 'Active'}
                                    </span>
                                </div>
                            </div>
                            
                            <div className="p-6 flex-grow flex flex-col justify-between">
                                <div>
                                    <h3 className="text-lg font-black text-black mb-1 truncate">{project.name}</h3>
                                    <p className="text-[10px] font-black text-black uppercase tracking-widest mb-4">By {project.developerDetails?.name || 'Top Developer'}</p>
                                    
                                    <div className="grid grid-cols-2 gap-4 mb-6">
                                        <div>
                                            <p className="text-[9px] font-black text-black uppercase tracking-widest mb-1">Config</p>
                                            <p className="text-sm font-black text-black uppercase">{project.overview?.configuration || 'N/A'}</p>
                                        </div>
                                        <div>
                                            <p className="text-[9px] font-black text-black uppercase tracking-widest mb-1">Price From</p>
                                            <p className="text-sm font-black text-black uppercase">{project.overview?.priceRange || 'On Request'}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center justify-between pt-4 border-t border-slate-50">
                                    <span className="text-[10px] font-black uppercase tracking-widest text-black underline">Explore Details</span>
                                    <i className="fa-solid fa-arrow-right text-black group-hover/card:translate-x-2 transition-transform"></i>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                {/* Right Scroll Indicator */}
                <div className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white border border-slate-100 shadow-lg rounded-full flex items-center justify-center cursor-pointer hover:bg-slate-50 transition-all z-10">
                    <i className="fa-solid fa-chevron-right text-slate-600 text-[12px]"></i>
                </div>
            </div>

            <style>{`
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
            `}</style>
        </div>
    );
};

export default LocalProjects;
